import styled, { css } from 'styled-components';
import palette from '../../../lib/styles/palette';
import React, { useState, useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { changeBody } from '../../../modules/conveyor/conveyorWriteSlice';

import { useSelector } from '../../../../node_modules/react-redux/dist/react-redux';
import {
    gearedMotor_rightAngle,
    gearedMotor_parallel,
    gearedMotor_gearWeight_rightAngle,
    gearedMotor_gearWeight_parallel,
    // gearedMotor_motorWeight_rightAngle,
    // gearedMotor_motorWeight_parallel,
} from '../../../lib/data/gearedMotor-data';
import {
    gears_rightAngle,
    gears_parallel,
    gearWeight_rightAngle,
    gearWeight_parallel,
} from '../../../lib/data/reducer-data';
import { useCallback } from 'react';
import { useMemo } from 'react';

import { formatDisplayValue } from '../../../lib/styles/perttierNumber';
// import { useRef } from 'react';
import { MultiOutput, MultiSelect } from '../common/MultiInput';
import AlertLabel from '../../common/AlertLabel';


const SpeedReducerDual = ({ reducers }) => {
    const dispatch = useDispatch();
    const language = useSelector((state) => state.language);
    const isEN = language.language === 'EN' ? true : false;
    const isJP = language.language === 'JP' ? true : false;
    const beltSpeed = useSelector((state) => state.conveyorWrite.body.input.beltSpeed);
    const drives = useSelector((state) => state.conveyorWrite.body.drives);
    const pulleys = useSelector((state) => state.conveyorWrite.body.pulleys);

    const [firstReducer, setFirstReducer] = useState(reducers?.[0] || {});
    const [secondReducer, setSecondReducer] = useState(reducers?.[1] || {});

    const [ratioRanking, setRatioRanking] = useState([]);

    /* reduction Ratio 선택 */
    const ratioRankingHelical = useMemo(
        () => [
            { text: 6.3, value: 6.3 },
            { text: 7.1, value: 7.1 },
            { text: 8.0, value: 8.0 },
            { text: 9.0, value: 9.0 },
            { text: 10.0, value: 10.0 },
            { text: 11.2, value: 11.2 },
            { text: 12.5, value: 12.5 },
            { text: 14.0, value: 14.0 },
            { text: 16.0, value: 16.0 },
            { text: 18.0, value: 18.0 },
            { text: 20.0, value: 20.0 },
            { text: 22.4, value: 22.4 },
            { text: 25.0, value: 25.0 },
            { text: 28.0, value: 28.0 },
            { text: 31.5, value: 31.5 },
            { text: 35.5, value: 35.5 },
            { text: 40.0, value: 40.0 },
            { text: 45.0, value: 45.0 },
            { text: 50.0, value: 50.0 },
        ],
        [],
    );

    const ratioRankingGearedMotor = useMemo(
        () => [
            { text: 6.3, value: 6.3 },
            { text: 7.1, value: 7.1 },
            { text: 8.0, value: 8.0 },
            { text: 9.0, value: 9.0 },
            { text: 10.0, value: 10.0 },
            { text: 11.2, value: 11.2 },
            { text: 12.5, value: 12.5 },
            { text: 14.0, value: 14.0 },
            { text: 16.0, value: 16.0 },
            { text: 18.0, value: 18.0 },
            { text: 20.0, value: 20.0 },
            { text: 22.4, value: 22.4 },
            { text: 25.0, value: 25.0 },
            { text: 28.0, value: 28.0 },
            { text: 31.5, value: 31.5 },
            { text: 35.5, value: 35.5 },
            { text: 40.0, value: 40.0 },
            { text: 45.0, value: 45.0 },
            { text: 50.0, value: 50.0 },
            { text: 56.0, value: 56.0 },
            { text: 63.0, value: 63.0 },
            { text: 71.0, value: 71.0 },
            { text: 80.0, value: 80.0 },
            { text: 90.0, value: 90.0 },
        ],
        [],
    );

    /* 모델 찾기 함수 */
    const getGearedMotor = useCallback((type, ratio, frequency, motorPower) => {
        // console.log('type, ratio, frequency, motorPower : ', type, ratio, frequency, motorPower);
        if (type === '1') {
            // GearedMotor-Vertical이면
            const selected = gearedMotor_rightAngle.find(
                (item) => item.ratio === Number(ratio) && item.frequency === Number(frequency),
            );
            if (!selected) {
                return;
                // alert('해당하는 모델이 없습니다.');
            }
            // console.log('selected : ', selected);
            const model = selected.models[motorPower];
            if (!model) {
                alert('Geared Motor에는 해당하는 모델이 없습니다.');
            }
            const weight = gearedMotor_gearWeight_rightAngle[model];

            return {
                model,
                weight,
            };
        } else if (type === '2') {
            // GearedMotor-Horizontal이면
            const selected = gearedMotor_parallel.find(
                (item) => item.ratio === Number(ratio) && item.frequency === Number(frequency),
            );
            if (!selected) {
                return;
                // alert('해당하는 모델이 없습니다.');
            }

            const model = selected.models[motorPower];
            if (!model) {
                alert('Geared Motor에는 해당하는 모델이 없습니다.');
            }
            const weight = gearedMotor_gearWeight_parallel[model];

            return {
                model,
                weight,
            };
        } else {
            alert('Type Invalid!!');
        }
    }, []);

    /* 모델 찾기 함수 */
    const getModel = useCallback((type, ratio, poles, frequency, requiredPower) => {
        // 해당 ratio, pole, frequency에 맞는 데이터를 필터링
        if (type === '3') {
            const selected = gears_rightAngle.find(
                (item) =>
                    item.ratio === Number(ratio) &&
                    item.poles === Number(poles) &&
                    item.frequency === Number(frequency),
            );
            if (!selected) {
                return { error: '해당 조건에 맞는 데이터가 없습니다.' };
            }
            // 허용동력이 requiredTorque보다 작은 첫번째 모델 찾기
            for (const [model, power] of Object.entries(selected.models)) {
                if (power !== null && power >= requiredPower) {
                    const weight = gearWeight_rightAngle[model];
                    return { model: model, allowablePower: power, weight }; // 조건을 만족하는 첫번째 모델을 반환
                }
            }
            return { error: '해당 동력 조건에 맞는 모델이 없습니다.' };
        } else if (type === '4') {
            const selected = gears_parallel.find(
                (item) =>
                    item.ratio === Number(ratio) &&
                    item.poles === Number(poles) &&
                    item.frequency === Number(frequency),
            );
            if (!selected) {
                return { error: '해당 조건에 맞는 데이터가 없습니다.' };
            }
            // 허용동력이 requiredTorque보다 작은 첫번째 모델 찾기
            for (const [model, power] of Object.entries(selected.models)) {
                if (power !== null && power >= requiredPower) {
                    const weight = gearWeight_parallel[model];
                    return { model: model, allowablePower: power, weight }; // 조건을 만족하는 첫번째 모델을 반환
                }
            }
            return { error: '해당 동력 조건에 맞는 모델이 없습니다.' };
        }
    }, []);

    // 타입 선택
    const handleChange = (e) => {
        const { name, value } = e.target;
        const [category, key] = name.split('_');

        if (category === '1st') {
            setFirstReducer((prev) => ({
                ...prev,
                [key]: value,
            }));
        } else if (category === '2nd') {
            setSecondReducer((prev) => ({
                ...prev,
                [key]: value,
            }));
        }
    };

    /* 1st Speed Reducer */
    // 타입별 감속비 가져오기
    useEffect(() => {
        if (firstReducer.type === '1' || firstReducer.type === '2') {
            setRatioRanking(ratioRankingGearedMotor);
        } else {
            setRatioRanking(ratioRankingHelical);
        }
    }, [firstReducer, ratioRankingGearedMotor, ratioRankingHelical]);

    // 감속비 계산
    useEffect(() => {
        // 모터 rpm
        const n = drives?.[0].motorRPM * (1 - drives?.[0].slipRatio / 100); // slip 고려

        // 감속기 rpm
        const D = parseFloat(pulleys?.[0].diaSelected / 1000); // Drive Pulley Diameter. mm -> m 환산
        const V = parseFloat(beltSpeed * 60); // 단위 m/s -> m/min 환산
        const N = V / (Math.PI * D); // Pulley의 회전수

        // 감속비
        const i = n / N;

        setFirstReducer((prev) => ({
            ...prev,
            reductionRatio: Math.ceil(i * 100) / 100,
        }));
    }, [beltSpeed, drives, pulleys]);

    //  모델 선정
    useEffect(() => {
        if (!firstReducer.reductionRatioSelected) {
            return;
        }
        const { poles, frequency, actualPower } = drives?.[0];
        if (!poles || !frequency || !actualPower) {
            return;
        }
        if (firstReducer.type === '1' || firstReducer.type === '2') {
            // Geared Motor면
            const { model, weight } = getGearedMotor(
                firstReducer.type,
                firstReducer.reductionRatioSelected,
                frequency,
                drives?.[0].selectedMotor,
            );

            setFirstReducer((prev) => ({
                ...prev,
                model,
                allowablePower: drives[0].selectedMotor * 1.25, // 테이블에 SF 1.25로 되어 있음.
                weight,
            }));
        } else if (firstReducer.type === '3' || firstReducer.type === '4') {
            // Geared Motor가 아니면
            const _actualPower = Math.max(actualPower?.load, actualPower?.noLoad);

            const { model, allowablePower, weight } = getModel(
                firstReducer.type,
                firstReducer.reductionRatioSelected,
                poles,
                frequency,
                _actualPower * 1.25, // SF 1.25로 고정
            );

            setFirstReducer((prev) => ({
                ...prev,
                model,
                allowablePower,
                weight,
            }));
        }
    }, [drives, firstReducer.reductionRatioSelected, firstReducer.type, getGearedMotor, getModel]);

    /* 2nd Speed Reducer */
    // 타입별 감속비 가져오기
    useEffect(() => {
        if (secondReducer.type === '1' || secondReducer.type === '2') {
            setRatioRanking(ratioRankingGearedMotor);
        } else {
            setRatioRanking(ratioRankingHelical);
        }
    }, [secondReducer, ratioRankingGearedMotor, ratioRankingHelical]);

    // 감속비 계산
    useEffect(() => {
        // 모터 rpm
        const n = drives?.[1].motorRPM * (1 - drives?.[1].slipRatio / 100); // slip 고려

        // 감속기 rpm
        const D = parseFloat(pulleys?.[1].diaSelected / 1000); // Drive Pulley Diameter. mm -> m 환산
        const V = parseFloat(beltSpeed * 60); // 단위 m/s -> m/min 환산
        const N = V / (Math.PI * D); // Pulley의 회전수

        // 감속비
        const i = n / N;

        setSecondReducer((prev) => ({
            ...prev,
            reductionRatio: Math.ceil(i * 100) / 100,
        }));
    }, [beltSpeed, drives, pulleys]);

    //  모델 선정
    useEffect(() => {
        if (!secondReducer.reductionRatioSelected) {
            return;
        }
        const { poles, frequency, actualPower } = drives?.[1];
        // console.log('poles, frequency, actualPower of drive[1] : ', poles, frequency, actualPower);
        if (!poles || !frequency || !actualPower) {
            return;
        }
        if (secondReducer.type === '1' || secondReducer.type === '2') {
            // Geared Motor면
            const { model, weight } = getGearedMotor(
                secondReducer.type,
                secondReducer.reductionRatioSelected,
                frequency,
                drives[1].selectedMotor,
            );

            setSecondReducer((prev) => ({
                ...prev,
                model,
                allowablePower: drives[1].selectedMotor * 1.25, // 테이블에 SF 1.25로 되어 있음.
                weight,
            }));
        } else if (secondReducer.type === '3' || secondReducer.type === '4') {
            // console.log(
            //     'type, ratio, poles, frequency, actualPower*1.5 : ',
            //     secondReducer.type,
            //     secondReducer.reductionRatioSelected,
            //     poles,
            //     frequency,
            //     actualPower * 1.25,
            // );

            // Geared Motor가 아니면
            const _actualPower = Math.max(actualPower?.load, actualPower?.noLoad);

            const { model, allowablePower, weight } = getModel(
                secondReducer.type,
                secondReducer.reductionRatioSelected,
                poles,
                frequency,
                _actualPower * 1.25, // SF 1.25로 고정
            );

            setSecondReducer((prev) => ({
                ...prev,
                model,
                allowablePower,
                weight,
            }));
        }
    }, [drives, secondReducer.reductionRatioSelected, secondReducer.type, getGearedMotor, getModel]);

    /* 리덕스에 쓰기 */
    useEffect(() => {
        dispatch(
            changeBody({
                key: 'reducers',
                value: [firstReducer, secondReducer],
            }),
        );
    }, [dispatch, firstReducer, secondReducer]);

    return (
        <>
            {/* Fluid Coupling */}
            <SubTitle>Speed Reducer:</SubTitle>
            <MultiSelect
                label="Type of Speed Reducer Arrangement"
                variable="-"
                variableName="type"
                unit="-"
                values={[firstReducer.type, secondReducer.type]}
                options={[
                    { text: 'Geared Motor-Vertical', value: 1 },
                    { text: 'Geared Motor-Horizontal', value: 2 },
                    { text: 'Bevel Helical', value: 3 },
                    { text: 'Parallel Helical', value: 4 },
                ]}
                onChange={handleChange}
                isRequired
            />
            <MultiOutput
                label="Actual Power @Reducer Low Speed Shaft"
                variable="-"
                variableName="-"
                unit="kW"
                values={[
                    Math.max(drives?.[0].actualPower?.load, drives?.[0].actualPower?.noLoad),
                    Math.max(drives?.[1].actualPower?.load, drives?.[1].actualPower?.noLoad),
                ]}
                // values={drives.map((drive) => {
                //     if (!drive) {
                //         return 0;
                //     }
                //     const load = drive.actualPower?.load ?? 0;
                //     const noLoad = drive.actualPower?.noLoad ?? 0;
                    
                //     return Math.max(load, noLoad);
                // })}
            />
            {/* <RowInput
                label="Safety Factor"
                variable="-"
                variableName="safetyFactor"
                unit="-"
                value={firstReducer.safetyFactor}
                onChange={handleChange}
            /> */}
            <MultiOutput
                label="Installed Motor"
                variable="-"
                variableName="-"
                unit="kW"
                values={[drives?.[0].selectedMotor, drives?.[1].selectedMotor]}
            />
            <MultiOutput
                label="Motor RPM"
                variable="RPM"
                variableName="-"
                unit="1/min"
                values={[drives?.[0].motorRPM, drives?.[1].motorRPM]}
            />
            <MultiOutput
                label="Slip Ratio"
                variable="-"
                variableName="slipRatio"
                unit="%"
                values={[drives?.[0].slipRatio, drives?.[1].slipRatio]}
            />
            <MultiOutput
                label="Reduction Ratio"
                variable="1/i"
                variableName="reductionRatio"
                unit="-"
                values={[firstReducer.reductionRatio, secondReducer.reductionRatio]}
            />
            <MultiSelect
                label={
                    <AlertLabel
                        label={isEN ? "Reduction Ratio Selected" : isJP ? "減速比選択" : "감속비 선택"}
                        message={isEN ? "To be checked with actual capacity under selected reduction ratio." :
                            isJP ? "選択された減速比によって決定されたベルト速度で実際の搬送量を確認する必要があります。" :
                            "선택된 감속비에 따라 결정된 벨트 속도로 실제 운반량을 점검해야 한다."
                        }
                    />
                }
                variable="-"
                variableName="reductionRatioSelected"
                unit="-"
                values={[firstReducer.reductionRatioSelected, secondReducer.reductionRatioSelected]}
                options={ratioRanking}
                onChange={handleChange}
                isRequired
            />
            {/* <MultiSelect
                label="Type of Arrangement"
                variable="-"
                variableName="type"
                unit="-"
                value={firstReducer.type}
                options={['Geared Motor-Right Angle', 'Geared Motor-Parallel', 'Helical-Right Angle', 'Helical-Parallel']}
                onChange={handleChange}
                isRequired
            /> */}
            <MultiOutput
                label="Selected Model"
                variable="-"
                variableName="-"
                unit="-"
                values={[firstReducer.model, secondReducer.model]}
            />
            <MultiOutput
                label="Allowable Power Transmission"
                variable="-"
                variableName="-"
                unit="kW"
                values={[firstReducer.allowablePower, secondReducer.allowablePower]}
            />
            <MultiOutput
                label="Weight"
                variable="-"
                variableName="-"
                unit="kg"
                values={[firstReducer.weight, secondReducer.weight]}
            />
        </>
    );
};

export default SpeedReducerDual;

/* =================   Styles   ================== */
export const Input = styled.input`
    width: 100%;
    box-sizing: border-box;
    border: none;
    outline: none;
    background-color: ${palette.cyan[0]};
    text-align: right;
    // width: 80px;
    padding: 0.25rem 0;
    padding-right: 0.5rem;
    font-size: 0.95rem;

    &::placeholder {
        color: ${palette.lime[5]};
        font-style: italic;
    }

    ${(props) =>
        props.isRequired &&
        css`
            background-color: ${palette.yachtBlue};
            color: white;
        `}
`;

export const RowInput = ({
    label,
    variable,
    unit,
    variableName,
    values,
    referenceValues,
    handleChange,
    isRequired,
}) => {
    return (
        <tr className="tr-hover-effect">
            <td style={{ width: '100%', padding: '0.5rem 1rem' }}>
                <span
                    style={{
                        display: 'block',
                        width: '100%',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                    }}
                >
                    {label}
                </span>
            </td>
            <td style={{ minWidth: '120px', fontSize: '0.9rem', color: `${palette.gray[6]}`, textAlign: 'right' }}>
                {variable}
            </td>
            <td
                style={{
                    minWidth: '120px',
                    textAlign: 'right',
                    paddingRight: '0.5rem',
                    // fontSize: isSub ? '0.85rem' : '0.95rem',
                    // color: isSub ? `${palette.gray[6]}` : null,
                }}
            >
                <Input
                    name={`1st_${variableName}`}
                    value={values[0]}
                    placeholder={referenceValues && referenceValues[0]}
                    onChange={handleChange}
                    isRequired={isRequired}
                />
            </td>
            <td
                style={{
                    minWidth: '120px',
                    textAlign: 'right',
                    paddingRight: '0.5rem',
                    // fontSize: isSub ? '0.85rem' : '0.95rem',
                    // color: isSub ? `${palette.gray[6]}` : null,
                }}
            >
                <Input
                    name={`2nd_${variableName}`}
                    value={values[1]}
                    placeholder={referenceValues && referenceValues[1]}
                    onChange={handleChange}
                    isRequired={isRequired}
                />
            </td>
            <td style={unitStyle}>{unit}</td>
        </tr>
    );
};

export const RowOutput = ({ label, variable, unit, values, isSub, isWarning }) => {
    return (
        <tr className="tr-hover-effect">
            <td style={{ width: '100%', padding: '0.5rem 1rem' }}>
                <span
                    style={{
                        display: 'block',
                        width: '100%',
                        paddingLeft: isSub ? '1rem' : 0,
                        color: isSub ? `${palette.gray[6]}` : null,
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                    }}
                >
                    {label}
                </span>
            </td>
            <td style={variableStyle}>{variable}</td>
            <td
                style={{
                    minWidth: '120px',
                    fontSize: isSub ? '0.85rem' : '0.95rem',
                    textAlign: 'right',
                    paddingRight: '1rem',
                    color: isSub ? `${palette.gray[6]}` : null,
                }}
            >
                {formatDisplayValue(values[0])}
            </td>
            <td
                style={{
                    minWidth: '120px',
                    fontSize: isSub ? '0.85rem' : '0.95rem',
                    textAlign: 'right',
                    paddingRight: '1rem',
                    color: isSub ? `${palette.gray[6]}` : null,
                }}
            >
                {formatDisplayValue(values[1])}
            </td>
            <td style={unitStyle}>{unit}</td>
        </tr>
    );
};

/* =================   Styles   ================== */
const Select = styled.select`
    width: 100%;
    border: none;
    outline: none;
    padding: 0.25rem 0;
    text-align: center;
    background-color: ${palette.cyan[0]};
    ${(props) =>
        props.isRequired &&
        css`
            background-color: ${palette.yachtBlue};
            color: white;
        `}
`;

export const RowSelect = ({ label, variable, unit, variableName, values, options, handleChange, isRequired }) => {
    return (
        <tr className="tr-hover-effect">
            <td style={{ width: '100%', minWidth: '500px', padding: '0.5rem 1rem' }}>
                <span
                    style={{
                        display: 'block',
                        width: '100%',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                    }}
                >
                    {label}
                </span>
            </td>
            <td style={{ textAlign: 'right' }}>-</td>
            <td style={{ width: '100px' }}>
                <Select name={`1st_${variableName}`} value={values[0]} onChange={handleChange} isRequired={isRequired}>
                    <option value="" selected disabled>
                        Select...
                    </option>
                    {options.map((item) => (
                        <option value={item.value}>{`${item.text}`}</option>
                    ))}
                </Select>
            </td>
            <td style={{ width: '100px' }}>
                <Select name={`2nd_${variableName}`} value={values[1]} onChange={handleChange} isRequired={isRequired}>
                    <option value="" selected disabled>
                        Select...
                    </option>
                    {options.map((item) => (
                        <option value={item.value}>{`${item.text}`}</option>
                    ))}
                </Select>
            </td>
            <td>-</td>
        </tr>
    );
};

const variableStyle = {
    minWidth: '100px',
    fontSize: '0.9rem',
    textAlign: 'right',
    color: `${palette.gray[6]}`,
};

const unitStyle = {
    minWidth: '60px',
    fontSize: '0.9rem',
    color: `${palette.gray[6]}`,
};

const SubTitle = styled.p`
    margin-left: 1rem;
    font-weight: 800;
`;
